import { BasicTable } from "@synergy/table";
import { Col, Flex, Row } from "antd";
import i18next from 'i18next';
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../../../../contexts/AuthContext";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";
import useFetch from "../../../../../../server/useFetch";
import Theme from "../../../../../../styles/Theme/Theme";
import { REACT_APP_COMMAND_INCIDENT_URL } from "../../../../../../utils/config/configs";
import { getColorByPriority } from "../../../../../../utils/hooks/getColorByPriority";
import { groupBy } from "../../../../../../utils/hooks/gourpBy";
import { NoData } from "../../../../Atomics/NoData";
import Spinner from "../../../../Atomics/Spinner";
import { Widget } from "../../../../Atomics/Widget";

const CustomTable = styled.div`
  .antd-basic-table {
    .ant-table {
      border-color: #e6f7ff;
    }

    .ant-table-thead > tr > th {
      background: transparent;
      color: ${Theme.color["green-deloitte"]};
    }

    .ant-table-thead > tr:hover > th {
      background: transparent;
      color: ${Theme.color["green-deloitte"]};
    }
  }
`;

export const BuildingIncidents = ({ item }) => {
  // Obtém a função de tradução do hook useTranslation
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();

  useEffect(() => {
    logger.info("User " + user + " entered BuildingIncidents successfully! Tenant: " + tenant);
  }, [])

  const { data: overviewIncidents, isFetching: overviewIncidentsIsFetching } = useFetch(
    "/incidents", "overviewIncidents",
    {
      tenant: item?.tenant,
      cityService: item?.id,
      includeClosed: true
    }, item?.tenant ?? false, null, query.middlewareCommandURL);

  return (
    <Row style={{ width: "100%", margin: "0px" }} gutter={[16, 16]}>
      <Col span={24} style={{ alignContent: "center" }}>
        <Row>
          <Col span={10}>
            <Row>
              <Col span={24}>
                <h3>
                  {item?.name} |  {t("Incidents").toUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {/* {currentFloor ? <> */}
      <Col span={8}>
        <Widget
          data={{
            background: "white",
            title: t("Current Incidents"),
            icon: null,
            charts: [
              {
                chartType: "simpleDonutChartApex",
                chartId: "donutChartOne",
                height: "212px",
                isFetching: overviewIncidentsIsFetching,
                data: overviewIncidents?.incidentsByPriority ? generateIncidentsByPriority(overviewIncidents?.incidents) : null,
              },
            ],
          }}
        />
      </Col>
      <Col span={8}>
        <Widget
          data={{
            background: "white",
            title: t("Top 5 Incidents"),
            icon: null,
            tooltip: t("message.by category"),
            charts: [
              {
                chartType: "horizontalBarChartApex", // Tipo de gráfico definido como lista de topo
                height: "200px", // Altura do gráfico
                isFetching: overviewIncidentsIsFetching,
                data: overviewIncidents?.incidents ? getTop5IncidentsByCategory(overviewIncidents?.incidents) : null,
              }
            ],
          }}
        />
      </Col>
      <Col span={8}>
        <Widget
          data={{
            background: "white",
            title: t("title.By Status"),
            height: '100%',
          }}
        >
          {getByStatusWidget(overviewIncidents?.incidents, t)}
        </Widget>
      </Col>
      <Col span={24} style={{ marginBottom: "20px" }}>
        <Widget
          data={{
            background: "white", // Define o fundo do widget como branco
            title: t("Incident List"), // Título do widget traduzido
            justify: "center"
          }}
        >
          {!overviewIncidentsIsFetching ?
            overviewIncidents?.incidents ? (
              <CustomTable>
                <BasicTable
                  // tableId="buildingsEventsTable"
                  tableConfiguration={tableConfiguration}
                  language={i18next.resolvedLanguage}
                  fetchData={overviewIncidents?.incidents.map((x, index) => {
                    x.openDate = x.openDate.replace("T", " ");
                    let decodedBase64 = '';
                    if (x.description) {
                      try {
                        //Verifica se a string é base64
                        if (/^[A-Za-z0-9+/=]+$/.test(x.description) && btoa(atob(x.description)) === x.description) {
                          decodedBase64 = atob(x.description);
                        }
                      } catch (e) {
                        console.error('Failed to decode base64 string:', e);
                      }
                    }
                    return { ...x, description: decodedBase64, status: t(x.status) };
                  })}
                  // hidePagination={true}
                  externalButton={true}
                  externalButtonTooltipMessage={t("Open incident in external system")}
                  handleExternal={(record) => {
                    console.log(record)
                    window.open(`${REACT_APP_COMMAND_INCIDENT_URL}${record.id}`, '_blank');
                  }}
                  // pagination={{ pageSize: 5 }}
                  pagination={{ showSizeChanger: true, defaultPageSize: 8, pageSizeOptions: [8, 10, 20, 30, 40] }}
                />
              </CustomTable>) :
              (<div
                style={{
                  height: "inherit",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                { }
                <NoData />
              </div>)
            :
            <Flex justify="center" align="center" style={{ height: '200px' }}>
              <Spinner stroke="green" size="42px" />
            </Flex>}
        </Widget>
      </Col>
    </Row>
  )
};

const getByStatusWidget = (data, t) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
        {[{ label: 'Registered', count: data?.filter(x => x.status === "Registered")?.length ?? 0 },
        { label: 'In Progress', count: data?.filter(x => x.status === "In Progress")?.length ?? 0 },
        { label: 'Hold', count: data?.filter(x => x.status === "Hold")?.length ?? 0 },
        { label: 'Resolved', count: data?.filter(x => x.status === "Resolved")?.length ?? 0 },
        { label: 'Closed', count: data?.filter(x => x.status === "Closed")?.length ?? 0 }].map((status, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '30%', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <h1 style={{ margin: '0', marginLeft: '5px' }}>{status.count}</h1>
            </div>
            <span>{t(status.label)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

const generateIncidentsByPriority = (data) => {
  const result = [];
  const openIncidents = data.filter(x => x.status == "In Progress" || x.status == "Registered");
  const byPriority = groupBy(openIncidents, 'priority');
  console.log('byPriority ', byPriority);
  Object.entries(byPriority).forEach(entry => {
    const [key, value] = entry;
    result.push({ name: key, value: value.length, color: Theme.color[getColorByPriority(key)] });
  })

  console.log('result ', result);
  return {
    "series": result,
    "categories": null,
    "tooltip": null,
    "markerSize": 3,
    "unit": "",
    "columnWidth": 20,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "total": result.length > 0 ? result.reduce((acc, curr) => acc + curr.value, 0) : 0,
    "disableTotal": false,
    "sideLegend": true,
    "dataLabelsOffset": 30,
    "customScale": 0.9,
    disableDataLabels: true,
    centerVerticalLegend: true,
  }
}

const getTop5IncidentsByCategory = (data) => {
  const series = [];
  const groupedByCategory = groupBy(data.filter(x => x.status === "In Progress" || x.status === "Registered"), 'category');
  Object.entries(groupedByCategory).slice(0, 5).forEach(entry => {
    const [key, value] = entry;
    series.push({ name: key, value: value.length, color: Theme.color["blue-4"] });
  })

  series.sort((a, b) => b.value - a.value);

  return {
    series: series,
    categories: null,
    xAxisType: null,
    labelFormat: null,
    tooltip: null,
    markerSize: null,
    unit: data.unit,
    columnWidth: 1,
    xAxisLabel: "",
    colors: ['blue-4'],
    hideCSVIcon: false,
    hideToolbar: true,
    yaxis: { offsetY: series && series.length === 1 ? -30 : -10 },
    isTopLabel: true,
    hideYAxisBorder: true,
    barHeight: '20%',
  };
}

const tableConfiguration = [
  {
    "title": "Data de Criação",
    "dataIndex": "openDate"
  },
  {
    "title": "Estado",
    "dataIndex": "status"
  },
  {
    "title": "Categoria",
    "dataIndex": "category"
  },
  {
    "title": "Descrição do evento",
    "dataIndex": "description",
    "width": "50%"
  },
  {
    "title": "Prioridade",
    "dataIndex": "priority"
  }
]